import { MutationHookOptions, useMutation } from '@apollo/client';

import { MOVE_MEMBERS_TO_COMPLETED } from '@frontend/app/queries/MoveMembersToCompleted';
import { MoveMembersToCompleted, MoveMembersToCompletedVariables } from '@frontend/app/queries/types/MoveMembersToCompleted';

type IOptions = MutationHookOptions<MoveMembersToCompleted, MoveMembersToCompletedVariables>;

export const useMoveMembersToCompleted = (options: IOptions = {}) => {
  const [moveMembersToCompleted, { loading }] = useMutation(MOVE_MEMBERS_TO_COMPLETED, options);

  return {
    moveMembersToCompleted,
    isMoveMembersToCompletedLoading: loading,
  };
};
